var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 204,
    viewBox: "0 0 203 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 40,
    width: 25,
    height: 125,
    fill: "#808BA4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 115,
    width: 25,
    height: 125,
    transform: "rotate(-90 39 115)",
    fill: "#808BA4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 0L137.44 39.75H65.5599L101.5 0Z",
    fill: "#808BA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 204L65.5599 164.25L137.44 164.25L101.5 204Z",
    fill: "#808BA4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.81402e-06 102.5L39.75 66.5599L39.75 138.44L-1.81402e-06 102.5Z",
    fill: "#808BA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M203 102.5L163.25 138.44L163.25 66.5599L203 102.5Z",
    fill: "#808BA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPan);
export default __webpack_public_path__ + "static/media/icon-pan.a408fb6578a22a03889be6fc82362e79.svg";
export { ForwardRef as ReactComponent };